import { Component, OnInit } from '@angular/core';
import { PrivacyPolicyService } from './privacy-policy.service';
import * as _ from 'lodash';
import { of as observableOf } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DialogService, LanguageService } from 'src/app/services';

@Component({
  selector: 'esc-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {

  ppPage = [];
  tcPage = [];
  pageNames = {
    ppPage: "PRIVACY_POLICY",
    tcPage: "TERMS_AND_CONDITION"
  }
  loading = false;
  networkError = false;
  loadingError = false;

  constructor(
    private service: PrivacyPolicyService,
    private dialogService:DialogService,
    private languageService:LanguageService
  ) { }

  ngOnInit(): void {
    this.getData();
  }

  getData() {
    this.loading = true;
    this.networkError = false;
    this.loadingError = false;

    this.service.getPrivacyPolicy().pipe(
      catchError(error => observableOf(error))
    ).subscribe(res => {
      if (res?.status === 0) {
        this.loading = false;
        this.networkError = true;
        return;
      }

      if (res?.value === "Unknown Error" || res?.error?.value === "Unknown Error") {
        this.dialogService.openSnackBar(this.languageService.getTranslation('MESSAGE_ERROR_UNKNOWN_ERROR', null));
        this.loading = false;
        this.loadingError = true;
        return;
      }

      this.ppPage = res.data.filter(item => item.page === this.pageNames.ppPage);
      this.tcPage = res.data.filter(item => item.page === this.pageNames.tcPage);

      this.loading = false;
    })
  }

  formatParagraph(data: string): string[] {
    return _.split(data, '|')
  }

  formatBulletForm(data:string) {

    const openUl = "<ul>";
    const closeUl = "</ul>";
    const openLi = "<li>";
    const closeLi = "</li>";
    const bulletData = this.parseBulletData(data);

    let htmlData = `${openUl}`;
    
    let currentIndent = 0;
    for (const line of bulletData) {
      if (line.level === 2) {
        const listItem = line.content.substr(2).trim();
        if (currentIndent <= 0) {
          htmlData += openUl;
        }
        htmlData += `${openLi}${listItem}${closeLi}`;
        currentIndent++;
      } else if (line.level === 1) {
        const listItem = line.content.substr(1).trim();
        if (currentIndent > 0) {
          htmlData += `${closeUl}`;
          currentIndent--;
        }
        htmlData += `${openLi}${listItem}${closeLi}`;
      }
    }

    return htmlData;

  }

  isBulletForm(data:string) {
    return data.includes("*");
  }

  private isDoubleLiner(text: string) {
    if (!text) {
      return;
    }

    if (text.startsWith('*')) {
      if (text.startsWith('**')) {
        return true;
      } else {
        return false;
      }
    } else {
      // not a one liner not a double liner
      return false;
    }
  }

  private parseBulletData(data: string): any[]{
    let bulletData = data.match(/(\*{1,2}[\s\S]*?)(?=\*{1,2}[\s\S]*|$)/g);

    let bullets = [];

    bulletData.map((item, index) => {
      if (!this.isDoubleLiner(item)) {
        bullets.push({ index: index, level: 1, content: item });
      } else {
        bullets.push({index: index, level:2, content: item})
      }
    })
    return bullets;
    
  }

}
